import React, { useEffect } from 'react';
import { Title, Text, Button, Container, Group } from '@mantine/core';
import classes from './GenericErrorPage.module.css';
import { Logger } from 'src/utils/Logger';

type Props = {
  title?: string;
  text?: React.ReactNode;
  showRefresh?: boolean;
  actions?: React.ReactNode;
} & (
  | {
      error: unknown;
      logError?: boolean;
    }
  | {
      error?: undefined;
      logError: false;
    }
);

export function GenericErrorPage({
  error,
  logError = true,
  title = 'Something went wrong...',
  text = 'Sorry, an unexpected error occurred. Please try to refresh the page and if the problem persists, contact support.',
  showRefresh = true,
  actions,
}: Props) {
  useEffect(() => {
    if (logError) {
      Logger.error('GenericErrorPage', error);
    }
  }, []);

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <Container className={classes.root}>
      <Title className={classes.title}>{title}</Title>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        {text}
      </Text>
      <Group justify="center">
        {showRefresh && (
          <Button variant="subtle" size="md" onClick={() => refreshPage()}>
            Refresh
          </Button>
        )}
        {actions}
      </Group>
    </Container>
  );
}
